import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class CommercialCleaningCoffsHarbour extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Commercial Cleaning Coffs Harbour | Office & Business Cleaning"
          description="Commercial cleaning Coffs Harbour for offices, restaurants and retail spaces. Reliable professional cleaning services."
          keywords="commercial cleaning coffs harbour, office cleaning coffs harbour, business cleaning coffs harbour, corporate cleaning coffs harbour, retail cleaning coffs harbour, restaurant cleaning coffs harbour, warehouse cleaning coffs harbour, industrial cleaning coffs harbour, strata cleaning coffs harbour, body corporate cleaning coffs harbour, medical cleaning coffs harbour, professional commercial cleaners coffs harbour, affordable commercial cleaning coffs harbour, contract cleaning coffs harbour, office sanitisation coffs harbour, hospitality cleaning coffs harbour, commercial kitchen cleaning coffs harbour, builders cleaning coffs harbour, post construction cleaning coffs harbour, after renovation cleaning coffs harbour, daily office cleaning coffs harbour, weekly commercial cleaning coffs harbour, reliable commercial cleaners coffs harbour, professional business cleaners coffs harbour, carpet cleaning office coffs harbour, window cleaning commercial coffs harbour, deep office cleaning coffs harbour, cleaning company coffs harbour, commercial cleaners near me coffs harbour, office maintenance cleaning coffs harbour"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Commercial Cleaning Services Coffs Harbour
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/commercial-cleaning-coffs-harbour/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Commercial Cleaning Services Coffs Harbour
                          </h4>
                          <p>
                            Businesses in Coffs Harbour rely on clean premises
                            to maintain professionalism and hygiene. Our
                            commercial cleaning Coffs Harbour service provides
                            structured cleaning solutions.
                          </p>

                          <h4 className="dlab-title m-t30">Services Include</h4>
                          <ul className="list-check primary">
                            <li>Office cleaning</li>
                            <li>Retail cleaning</li>
                            <li>Restaurant cleaning</li>
                            <li>Warehouse cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Why Choose Our Team
                          </h4>
                          <ul className="list-check primary">
                            <li>Experienced professionals</li>
                            <li>Flexible schedules</li>
                            <li>Reliable service</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default CommercialCleaningCoffsHarbour;
